import { fromJS, List } from 'immutable';

import * as _ from 'lodash';

import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';
import * as marketAreaActions from '../actions/marketArea';

import { fetchingState } from '@constants';

// const updateStateArrayItem = (state, action, arrayName, idFieldName) =>
//   state.setIn(
//     [arrayName, 'data'],
//     fromJS(
//       state
//         .getIn([arrayName, 'data'])
//         .toJS()
//         .map(x =>
//           x[idFieldName] === _.get(action, `data.results[0].${idFieldName}`)
//             ? action.data.results[0]
//             : x,
//         ),
//     ),
//   );

const initialState = {
  marketAreaSearch: { data: [], state: null },
  pagination: {
    count: 0,
    page: 1,
    rowsPerPage: 10,
    rowsPerPageOptions: [5, 10, 25, 50, 100, 500, 1000],
  },
  fileList: { data: [], state: null },
  fileMarketArea: {},
  generalInfo: { data: {}, state: null },
  submittedAnalysis: { data: {}, state: null },
  statistics: { data: {}, state: null },
  abstractSubdivisions: { data: [], state: null },
  salesTypes: { data: [], state: null },
  salesSource: { data: [], state: null },
  ratioTypes: { data: [], state: null },
  saleQualifiers: { data: [], state: null },
  searchParameters: { data: {}, state: null },
  sales: { sales: [], outliers: [], stats: {}, state: null },
  buildingPermitSummary: { data: [], state: null },
  builders: { data: [], state: null },
  rechecks: { data: [], state: null },
  protestCounts: { data: [], state: null },
  appraisers: { data: [], state: null },
  codeFiles: { data: {}, state: null },

  trendanalysissales: { data: [], state: null },
  population: {
    data: {
      current: {},
      prior: {},
    },
    state: null,
  },
  populationForCurrent: { data: [], state: null },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case marketAreaActions.FETCH_MARKET_AREA_FILES[START]: {
      return state.setIn(['fileList', 'state'], fetchingState.FETCHING);
    }
    case marketAreaActions.FETCH_MARKET_AREA_FILES[SUCCESS]: {
      return state
        .setIn(['fileList', 'state'], fetchingState.LOADED)
        .setIn(
          ['fileList', 'data'],
          fromJS(
            _.get(action, 'data.results[0].appealEvidenceFileAttachments', []),
          ),
        )
        .setIn(
          ['fileMarketArea'],
          fromJS(_.get(action, 'data.results[0]', [])),
        );
    }
    case marketAreaActions.FETCH_MARKET_AREA_FILES[ERROR]: {
      return state.setIn(['fileList', 'state'], fetchingState.ERROR);
    }
    case marketAreaActions.RESET_SALES: {
      return state
        .setIn(
          ['sales'],
          fromJS({ sales: [], outliers: [], stats: {}, state: null }),
        )
        .setIn(['searchParameters'], fromJS({ data: {}, state: null }));
    }
    case marketAreaActions.SEARCH_MARKET_AREA[START]: {
      return state
        .setIn(['marketAreaSearch', 'state'], fetchingState.FETCHING)
        .setIn(['pagination', 'page'], action.page)
        .setIn(['pagination', 'rowsPerPage'], action.pageSize);
    }
    case marketAreaActions.SEARCH_MARKET_AREA[SUCCESS]: {
      return state
        .setIn(['marketAreaSearch', 'state'], fetchingState.LOADED)
        .setIn(
          ['marketAreaSearch', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        )
        .setIn(
          ['pagination', 'count'],
          _.get(action, 'data.totalMarketArea.marketAreaCount', 0),
        );
    }
    case marketAreaActions.SEARCH_MARKET_AREA[ERROR]: {
      return state.setIn(['marketAreaSearch', 'state'], fetchingState.ERROR);
    }

    case marketAreaActions.CHANGE_PAGE: {
      return state.setIn(['pagination', 'page'], action.payload);
    }
    case marketAreaActions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(['pagination', 'rowsPerPage'], action.payload);
    }

    case marketAreaActions.FETCH_MARKET_AREA_GENERAL_INFO[START]: {
      return state.setIn(['generalInfo', 'state'], fetchingState.FETCHING);
    }
    case marketAreaActions.FETCH_MARKET_AREA_GENERAL_INFO[SUCCESS]: {
      return state
        .setIn(['generalInfo', 'state'], fetchingState.LOADED)
        .setIn(
          ['generalInfo', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case marketAreaActions.FETCH_MARKET_AREA_GENERAL_INFO[ERROR]: {
      return state.setIn(['statistics', 'state'], fetchingState.ERROR);
    }

    case marketAreaActions.UPDATE_MARKET_AREA_GENERAL_INFO[SUCCESS]:
      return state.setIn(
        ['generalInfo', 'data'],
        fromJS(_.get(action, 'data.results[0]', {})),
      );

    case marketAreaActions.SUBMIT_MARKET_AREA_DETAIL[START]:
      return state.setIn(['submittedAnalysis', 'data'], fromJS({}));
    case marketAreaActions.SUBMIT_MARKET_AREA_DETAIL[SUCCESS]:
      let newState = state.setIn(
        ['generalInfo', 'data'],
        fromJS({
          ...state.getIn(['generalInfo', 'data']).toJS(),
          ..._.get(action, 'data.results[0]', {}),
        }),
      );
      return newState.setIn(
        ['submittedAnalysis', 'data'],
        fromJS(_.get(action, 'data.results[0]', {})),
      );

    case marketAreaActions.REOPEN_MARKET_AREA[SUCCESS]:
      return state.setIn(
        ['generalInfo', 'data'],
        fromJS({
          ...state.getIn(['generalInfo', 'data']).toJS(),
          ..._.get(action, 'data.results[0]', {}),
        }),
      );

    case marketAreaActions.FETCH_MARKET_AREA_STATISTICS[START]: {
      return state.setIn(['statistics', 'state'], fetchingState.FETCHING);
    }
    case marketAreaActions.FETCH_MARKET_AREA_STATISTICS[SUCCESS]: {
      return state
        .setIn(['statistics', 'state'], fetchingState.LOADED)
        .setIn(
          ['statistics', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case marketAreaActions.FETCH_MARKET_AREA_STATISTICS[ERROR]: {
      return state.setIn(['statistics', 'state'], fetchingState.ERROR);
    }

    case marketAreaActions.PROCESS_MARKET_AREA_STATISTICS[SUCCESS]: {
      return state
        .setIn(['statistics', 'state'], fetchingState.LOADED)
        .setIn(
          ['statistics', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }

    case marketAreaActions.FETCH_MARKET_AREA_SUBDIVISIONS[START]: {
      return state.setIn(
        ['abstractSubdivisions', 'state'],
        fetchingState.FETCHING,
      );
    }
    case marketAreaActions.FETCH_MARKET_AREA_SUBDIVISIONS[SUCCESS]: {
      return state
        .setIn(['abstractSubdivisions', 'state'], fetchingState.LOADED)
        .setIn(
          ['abstractSubdivisions', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case marketAreaActions.FETCH_MARKET_AREA_SUBDIVISIONS[ERROR]: {
      return state.setIn(
        ['abstractSubdivisions', 'state'],
        fetchingState.ERROR,
      );
    }

    case marketAreaActions.FETCH_SALES_TYPES[START]: {
      return state.setIn(['salesTypes', 'state'], fetchingState.FETCHING);
    }
    case marketAreaActions.FETCH_SALES_TYPES[SUCCESS]: {
      return state
        .setIn(['salesTypes', 'state'], fetchingState.LOADED)
        .setIn(
          ['salesTypes', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case marketAreaActions.FETCH_SALES_TYPES[ERROR]: {
      return state.setIn(['salesTypes', 'state'], fetchingState.ERROR);
    }

    case marketAreaActions.FETCH_SALES_SOURCE[START]: {
      return state.setIn(['salesSource', 'state'], fetchingState.FETCHING);
    }
    case marketAreaActions.FETCH_SALES_SOURCE[SUCCESS]: {
      return state
        .setIn(['salesSource', 'state'], fetchingState.LOADED)
        .setIn(
          ['salesSource', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case marketAreaActions.FETCH_SALES_SOURCE[ERROR]: {
      return state.setIn(['salesSource', 'state'], fetchingState.ERROR);
    }

    case marketAreaActions.FETCH_RATIO_TYPES[START]: {
      return state.setIn(['ratioTypes', 'state'], fetchingState.FETCHING);
    }
    case marketAreaActions.FETCH_RATIO_TYPES[SUCCESS]: {
      return state
        .setIn(['ratioTypes', 'state'], fetchingState.LOADED)
        .setIn(
          ['ratioTypes', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case marketAreaActions.FETCH_RATIO_TYPES[ERROR]: {
      return state.setIn(['ratioTypes', 'state'], fetchingState.ERROR);
    }

    case marketAreaActions.FETCH_SALE_QUALIFIERS[START]: {
      return state.setIn(['saleQualifiers', 'state'], fetchingState.FETCHING);
    }
    case marketAreaActions.FETCH_SALE_QUALIFIERS[SUCCESS]: {
      return state
        .setIn(['saleQualifiers', 'state'], fetchingState.LOADED)
        .setIn(
          ['saleQualifiers', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case marketAreaActions.FETCH_SALE_QUALIFIERS[ERROR]: {
      return state.setIn(['saleQualifiers', 'state'], fetchingState.ERROR);
    }

    case marketAreaActions.FETCH_SALE_SEARCH_PARAMETERS[START]: {
      return state.setIn(['searchParameters', 'state'], fetchingState.FETCHING);
    }
    case marketAreaActions.FETCH_SALE_SEARCH_PARAMETERS[SUCCESS]: {
      return state
        .setIn(['searchParameters', 'state'], fetchingState.LOADED)
        .setIn(
          ['searchParameters', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case marketAreaActions.FETCH_SALE_SEARCH_PARAMETERS[ERROR]: {
      return state.setIn(['searchParameters', 'state'], fetchingState.ERROR);
    }

    case marketAreaActions.FETCH_SALES[START]: {
      return state.setIn(['sales', 'state'], fetchingState.FETCHING);
    }
    case marketAreaActions.FETCH_SALES[SUCCESS]: {
      return state
        .setIn(['sales', 'state'], fetchingState.LOADED)
        .setIn(
          ['sales', 'sales'],
          fromJS(_.get(action, 'data.results.sales', [])),
        )
        .setIn(
          ['sales', 'outliers'],
          fromJS(_.get(action, 'data.results.outliers', [])),
        )
        .setIn(
          ['sales', 'stats'],
          fromJS(_.get(action, 'data.results.saleRatioStats', {})),
        );
    }
    case marketAreaActions.FETCH_SALES[ERROR]: {
      return state.setIn(['sales', 'state'], fetchingState.ERROR);
    }

    case marketAreaActions.FETCH_BUILDING_PERMIT_SUMMARY[START]: {
      return state.setIn(
        ['buildingPermitSummary', 'state'],
        fetchingState.FETCHING,
      );
    }
    case marketAreaActions.FETCH_BUILDING_PERMIT_SUMMARY[SUCCESS]: {
      return state
        .setIn(['buildingPermitSummary', 'state'], fetchingState.LOADED)
        .setIn(
          ['buildingPermitSummary', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case marketAreaActions.FETCH_BUILDING_PERMIT_SUMMARY[ERROR]: {
      return state.setIn(
        ['buildingPermitSummary', 'state'],
        fetchingState.ERROR,
      );
    }

    case marketAreaActions.FETCH_BUILDERS[START]: {
      return state.setIn(['builders', 'state'], fetchingState.FETCHING);
    }
    case marketAreaActions.FETCH_BUILDERS[SUCCESS]: {
      return state
        .setIn(['builders', 'state'], fetchingState.LOADED)
        .setIn(['builders', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case marketAreaActions.FETCH_BUILDERS[ERROR]: {
      return state.setIn(['builders', 'state'], fetchingState.ERROR);
    }

    case marketAreaActions.INSERT_MARKET_AREA_BUILDER[SUCCESS]:
      return state.setIn(
        ['builders', 'data'],
        fromJS([
          ...state.getIn(['builders', 'data'], List([])).toJS(),
          ..._.get(action, 'data.results', []),
        ]),
      );

    case marketAreaActions.DELETE_MARKET_AREA_BUILDER[SUCCESS]:
      return state.setIn(
        ['builders', 'data'],
        fromJS(
          state
            .getIn(['builders', 'data'], List([]))
            .toJS()
            .filter(b => b.builder !== action.builder),
        ),
      );

    case marketAreaActions.FETCH_RECHECKS[START]: {
      return state.setIn(['rechecks', 'state'], fetchingState.FETCHING);
    }
    case marketAreaActions.FETCH_RECHECKS[SUCCESS]: {
      return state
        .setIn(['rechecks', 'state'], fetchingState.LOADED)
        .setIn(['rechecks', 'data'], fromJS(_.get(action, 'data.results', {})));
    }
    case marketAreaActions.FETCH_RECHECKS[ERROR]: {
      return state.setIn(['rechecks', 'state'], fetchingState.ERROR);
    }

    case marketAreaActions.FETCH_PROTEST_COUNTS[START]: {
      return state.setIn(['protestCounts', 'state'], fetchingState.FETCHING);
    }
    case marketAreaActions.FETCH_PROTEST_COUNTS[SUCCESS]: {
      return state
        .setIn(['protestCounts', 'state'], fetchingState.LOADED)
        .setIn(
          ['protestCounts', 'data'],
          fromJS(_.get(action, 'data.results', {})),
        );
    }
    case marketAreaActions.FETCH_PROTEST_COUNTS[ERROR]: {
      return state.setIn(['protestCounts', 'state'], fetchingState.ERROR);
    }

    case marketAreaActions.FETCH_TREND_ANALYSIS_SALES[START]: {
      return state.setIn(
        ['trendanalysissales', 'state'],
        fetchingState.FETCHING,
      );
    }
    case marketAreaActions.FETCH_TREND_ANALYSIS_SALES[SUCCESS]: {
      return state
        .setIn(['trendanalysissales', 'state'], fetchingState.LOADED)
        .setIn(
          ['trendanalysissales', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case marketAreaActions.FETCH_TREND_ANALYSIS_SALES[ERROR]: {
      return state.setIn(['trendanalysissales', 'state'], fetchingState.ERROR);
    }

    case marketAreaActions.FETCH_MARKET_AREA_POPULATION[START]: {
      return state.setIn(['population', 'state'], fetchingState.FETCHING);
    }
    case marketAreaActions.FETCH_MARKET_AREA_POPULATION[SUCCESS]: {
      return state
        .setIn(['population', 'state'], fetchingState.LOADED)
        .setIn(
          ['population', 'data', 'current'],
          fromJS(_.get(action, 'data.current.results', {})),
        )
        .setIn(
          ['population', 'data', 'prior'],
          fromJS(_.get(action, 'data.prior.results', {})),
        );
    }
    case marketAreaActions.FETCH_MARKET_AREA_POPULATION[ERROR]: {
      return state.setIn(['population', 'state'], fetchingState.ERROR);
    }

    case marketAreaActions.FETCH_APPRAISERS[START]: {
      return state.setIn(['appraisers', 'state'], fetchingState.FETCHING);
    }
    case marketAreaActions.FETCH_APPRAISERS[SUCCESS]: {
      return state
        .setIn(['appraisers', 'state'], fetchingState.LOADED)
        .setIn(
          ['appraisers', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case marketAreaActions.FETCH_APPRAISERS[ERROR]: {
      return state.setIn(['appraisers', 'state'], fetchingState.ERROR);
    }

    case marketAreaActions.FETCH_CODE_FILE[SUCCESS]:
      return state.setIn(
        ['codeFiles', 'data', action.name],
        fromJS(action.data ? action.data.results : []),
      );

    case marketAreaActions.FETCH_SUBMISSION_STATISTICS[START]: {
      return state.setIn(
        ['submittedAnalysis', 'state'],
        fetchingState.FETCHING,
      );
    }
    case marketAreaActions.FETCH_SUBMISSION_STATISTICS[SUCCESS]: {
      return state
        .setIn(['submittedAnalysis', 'state'], fetchingState.LOADED)
        .setIn(
          ['submittedAnalysis', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case marketAreaActions.FETCH_SUBMISSION_STATISTICS[ERROR]: {
      return state.setIn(['submittedAnalysis', 'state'], fetchingState.ERROR);
    }

    default:
      return state;
  }
};
